// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tornadus_incarnate: PokeData = {
  "id": 641,
  "name": "tornadus-incarnate",
  "height": 15,
  "weight": 630,
  "base_experience": 261,
  "types": [
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "tackle",
    "thrash",
    "leer",
    "bite",
    "agility",
    "swagger",
    "twister",
    "rain-dance",
    "crunch",
    "uproar",
    "revenge",
    "astonish",
    "air-cutter",
    "extrasensory",
    "hammer-arm",
    "tailwind",
    "dark-pulse",
    "air-slash",
    "nasty-plot",
    "hurricane",
    "bleakwind-storm"
  ],
  "moves": [
    "gust",
    "tackle",
    "leer",
    "bite",
    "rain-dance",
    "crunch",
    "tailwind",
    "dark-pulse",
    "air-slash",
    "hurricane",
    "brave-bird",
    "acrobatics",
    "chatter"
  ],
  "evolution_chain": {
    "id": 328,
    "item": null,
    "species": [
      {
        "name": "tornadus",
        "order": 642,
        "types": [
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 98,
    "speed": 142,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
